import type { ReactNode } from "react";
import clsx from "clsx";

export type StayContextItem = {
  key: string;
  icon?: ReactNode;
  label?: string;
  value: string;
};

type Props = {
  items: StayContextItem[];
  className?: string;
  ariaLabel?: string;
};

/** Compact recap of what the guest already chose (dates, nights, vehicle, pitch …). */
export function StayContextBar({ items, className, ariaLabel }: Props) {
  const visible = items.filter((item) => item.value.trim().length > 0);
  if (visible.length === 0) return null;
  return (
    <ul className={clsx("bk-context-bar", className)} aria-label={ariaLabel}>
      {visible.map((item) => (
        <li key={item.key} className="bk-chip">
          {item.icon}
          {item.label ? <span className="sr-only">{item.label}: </span> : null}
          <span className="bk-chip__value">{item.value}</span>
        </li>
      ))}
    </ul>
  );
}
